module.exports = __webpack_public_path__ + "static/media/kefu_pc.dce0d7c8.svg";